import React, { PureComponent } from 'react'
import Slider from 'react-slick'

// import SliderWithScrollbar from '../SliderWithScrollbar'

import { NextArrow, PrevArrow } from 'components/ui/SliderArrows'

/*VIEW*/
// import Img from "components/Img";

/*Ui*/

import './style'
import './media'

class ReviewSlider extends PureComponent {
    SETTINGS = {
        slidesToShow: 3,
        // variableWidth: true,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        speed: 350,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        touchMove: true,
        // focusOnSelect: true,
        centerMode: false,
        swipeToSlide: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1900,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    dots: false,
                }
            },
            {
                breakpoint: 1000,
                settings: { 
                    slidesToShow: 1,
                    dots: false,
                }
            },
            {
                breakpoint: 700,
                settings: { 
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                }
            }
            
        ] 
    }

    render() {
        const { list = [] } = this.props

        return (
            <Slider
                {...this.SETTINGS}
                
                className="review-slider"
            >
                {list}
            </Slider>
        );
    }
}

export default ReviewSlider